export const SIGNIN = '/sign-in';
export const WELCOME = '/dashboard';
export const MECOMPANIES = '/dashboard/me/companies';
export const COMPANYMETRICS = '/dashboard/metrics';
export const COMPANYREPORTS = '/dashboard/reports';
export const COMPANYSETTINGS = '/dashboard/settings';
export const COMPANYIMPORT = '/dashboard/import';
export const MECOMPANY = '/dashboard/me/companies/:id';
export const USERS = '/dashboard/users';
export const COMPANIES = '/dashboard/companies';
export const COMPANY = '/dashboard/companies/:id';
